module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal integrations animated fadeIn"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('div', {
    staticClass: "integrations-hero"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('integrations_modal.workpapers_integrations')))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium explore",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations_modal.integrations_all')))])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "api"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('integrations_modal.api_token_required')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('integrations_modal.api_token_message')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "href": "/settings#/api"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations_modal.api_token_settings')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('integrations_modal.some_integration_examples')))])]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "integration-card"
  }, [_vm._m(1), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('integrations_modal.slack')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('integrations_modal.slack_message')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations_modal.use_this_zap')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "integration-card"
  }, [_vm._m(2), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('integrations_modal.trello')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('integrations_modal.trello_message')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations_modal.use_this_zap')))])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "integration-card"
  }, [_vm._m(3), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('integrations_modal.dropbox')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('integrations_modal.dropbox_message')))]), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations_modal.use_this_zap')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("{{ $t('integrations_modal.integrations_message', { link: '"), _c('a', {
    attrs: {
      "href": "https://zapier.com",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "/images/zapier.png"
    }
  })]), _vm._v("' }) }}")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logos"
  }, [_c('img', {
    attrs: {
      "src": "/images/integrations/slack.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("+")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/images/integrations/workpapers.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logos"
  }, [_c('img', {
    attrs: {
      "src": "/images/integrations/trello.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("+")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/images/integrations/workpapers.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logos"
  }, [_c('img', {
    attrs: {
      "src": "/images/integrations/dropbox.png"
    }
  }), _vm._v(" "), _c('span', [_vm._v("+")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/images/integrations/workpapers.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b284d41","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/integrations-modal.vue
// module id = 538
// module chunks = 0